import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import "./add.css"
import { BannerData } from '../posting/Socialarray'
import user from "../assets/user.png"
import share from "../assets/link.png"
import dot from "../assets/dot.png"
import feed from "../assets/feed2.png"
import Directories from '../profile/Directories'


function Adds() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5", position: "relative" }}>
            <Navbars show="none" />
            {/* <h1>posting</h1> */}
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />

                <div className='inner_div   mb-3 pb-4 pt-3 ' style={{ width: "100%", backgroundColor: "transparent", boxShadow: "none" }}>
                    <div className='d-flex justify-content-between gap-3 pt-4 flex-wrap ' >
                        <p className='adx_no'>Cube ADX - #00019298812</p>
                        <div className='d-flex gap-1'>
                            <p className='balance'>Your Balance:</p>
                            <p>$1000.00</p>
                        </div>
                    </div>
                    <div className='row mobile_row'>
                        <div className='col-lg-8 col-md-12 col-sm-12'>
                            <div>
                                {
                                    BannerData.map((e) => {
                                        return (<>
                                            <p className='banner_heading ' style={{ marginTop: "20px" }}>{e.heading}</p>
                                            <div className='banner_card'>
                                                <div className='ps-3 pt-3 inner_banner'>
                                                    <div className='d-flex gap-1 align-items-center banner_user mt-2'>
                                                        <img src={user} />
                                                        <div className='d-flex gap-1 flex-wrap'>
                                                            <p className='banner_name'>{e.name}</p>
                                                            <p className='banner_mail'>{e.mail}</p>
                                                        </div>
                                                    </div>
                                                    <p className='banner_text mt-1'>{e.text}<span style={{ color: "rgba(45, 156, 219, 1)" }}>@samuel</span></p>
                                                    <div className='d-flex align-items-center justify-content-between w-100 mt-4 banner_btn banner_text'>

                                                        <button className='call_btn'>Call Now</button>
                                                        <div className='d-flex gap-2   align-items-center'>
                                                            <img src={share} />
                                                            <div className='d-flex gap-1'>
                                                                <img className='dot' src={dot} />
                                                                <img className='dot' src={dot} />
                                                                <img className='dot' src={dot} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <img style={{ width: "100%" }} src={feed} />
                                                </div>






                                            </div>


                                        </>)
                                    })
                                }
                            </div>

                        </div>
                        <div className='col-lg-4 col-md-12 col-sm-12'>
                            <div className='d-flex align-items-end ' style={{height:"100%"}} >
                                <Directories/>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-center mt-5'>
                        <button className='update_btn'>Update</button>
                    </div>

                </div>

            </div>
        </div>





    </>

    )
}

export default Adds